// API Configuration for Netlify Functions

// Determine API base URL based on environment
export const API_BASE_URL = import.meta.env.PROD
  ? '/.netlify/functions'  // Production (Netlify)
  : '/.netlify/functions'; // Local dev with Netlify Dev CLI

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  AUTH_REGISTER: `${API_BASE_URL}/auth-register`,
  AUTH_LOGIN: `${API_BASE_URL}/auth-login`,
  AUTH_ME: `${API_BASE_URL}/auth-me`,
  SETUP_ADMIN: `${API_BASE_URL}/setup-admin`,

  // Blog
  BLOG_POSTS: `${API_BASE_URL}/blog-posts`,
  BLOG_POST: `${API_BASE_URL}/blog-post`,
  BLOG_CREATE: `${API_BASE_URL}/blog-create`,
  BLOG_UPDATE: `${API_BASE_URL}/blog-update`,
  BLOG_DELETE: `${API_BASE_URL}/blog-delete`,
  BLOG_CATEGORIES: `${API_BASE_URL}/blog-categories`,

  // Products
  PRODUCTS: `${API_BASE_URL}/products`,
  PRODUCT: `${API_BASE_URL}/product`,
  PRODUCT_CREATE: `${API_BASE_URL}/product-create`,
  PRODUCT_UPDATE: `${API_BASE_URL}/product-update`,
  PRODUCT_DELETE: `${API_BASE_URL}/product-delete`,
  PRODUCT_DOWNLOAD: `${API_BASE_URL}/product-download`,

  // Orders
  ORDER_CREATE: `${API_BASE_URL}/order-create`,
  ORDER_VERIFY: `${API_BASE_URL}/order-verify`,
  ORDERS: `${API_BASE_URL}/orders`,
  ORDERS_ADMIN: `${API_BASE_URL}/orders-admin`,

  // Premium Access
  PREMIUM_ACCESS: `${API_BASE_URL}/premium-access`,

  // Other
  CONTACT: `${API_BASE_URL}/contact`,
  UPLOAD: `${API_BASE_URL}/upload`
};

// Helper function to get auth token
export const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

// Helper function to check if user is logged in
export const isAuthenticated = () => {
  return !!getAuthToken();
};

// Helper function to get current user
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

// Helper function to logout
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.location.href = '/';
};
